import React from 'react';

export default function FloatingBottomBar({ cart, currency, totalPrice, totalItemsCount, onOpenCart, onOpenWhatsAppChat }) {
  return (
    <div style={bottomContainerStyle}>
      {cart.length > 0 && (
        <div style={floatingCartBar} onClick={onOpenCart}>
          <div>
            <span style={cartBadgeStyle}>{totalItemsCount}</span>
            <span style={{ fontWeight: '600' }}>View Order</span>
          </div>
          <span style={{ fontWeight: 'bold' }}>{currency} {totalPrice}</span>
        </div>
      )}

      <button onClick={onOpenWhatsAppChat} style={whatsappChatBtn}>
        💬 Chat on WhatsApp
      </button>
    </div>
  );
}

const bottomContainerStyle = { position: 'fixed', bottom: '10px', left: '50%', transform: 'translateX(-50%)', width: 'calc(100% - 1.5rem)', maxWidth: '450px', display: 'flex', flexDirection: 'column', gap: '0.5rem', zIndex: 100 };
const floatingCartBar = { background: '#10B981', color: '#FFF', padding: '0.75rem 1.25rem', borderRadius: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)' };
const cartBadgeStyle = { background: '#FFF', color: '#10B981', borderRadius: '50%', padding: '0.1rem 0.5rem', fontWeight: 'bold', marginRight: '0.5rem', fontSize: '0.85rem' };
const whatsappChatBtn = { width: '100%', background: '#25D366', color: '#FFF', border: 'none', padding: '0.7rem', borderRadius: '25px', fontWeight: 'bold', fontSize: '0.9rem', cursor: 'pointer', boxShadow: '0 4px 10px rgba(37, 211, 102, 0.3)' };